import {Plugins} from '@packages/systems/wfdl';

import {
  VisibilityConditions,
  visibilityConditionsToBoolean,
  booleanToVisibilityConditions,
} from './dataTypes/VisibilityConditions';

export const plugin = Plugins.PrivilegedPlugin({
  dataTypes: {VisibilityConditions},
  values: {
    visibilityConditionsToBoolean,
    booleanToVisibilityConditions,
  },
});
